/*
 * @Author: 
 * @Date: 2022-01-23 15:48:50
 * @LastEditTime: 2022-01-23 15:50:42
 * @LastEditors: your name
 * @Description: 治安巡防接口
 */
import request from "@/utils/request";

/*
 * @Author: 
 * @LastEditors: your name
 * @Description: 巡防员
 */
// 巡防员保存
export const personnelSave = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/personnel_info/save",
    data: data,
    method: "POST"
  });
};
// 巡防员删除
export const personnelDetele = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/personnel_info/detele",
    data: data,
    method: "POST"
  });
};
// 巡防员列表
export const personnelInfo = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/personnel_info/list",
    data: data,
    method: "POST"
  });
};

// 修改账户状态列表
export const startStopAccount = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/personnel_info/start_stop/account",
    data: data,
    method: "POST"
  });
};

// 重置密码
export const passwordReset = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/personnel_info/password/reset",
    data: data,
    method: "POST"
  });
};

/*
 * @Author: 
 * @LastEditors: your name
 * @Description: 线索管理
 */

// 线索列表
export const userList = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/clue/user/list",
    data: data,
    method: "POST"
  });
};

// 线索核实
export const userVerify = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/clue/user/verify",
    data: data,
    method: "POST"
  });
};

/*
 * @Author: 
 * @LastEditors: your name
 * @Description: 巡防任务
 */

// 任务添加
export const taskSave = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_info/user/add",
    data: data,
    method: "POST"
  });
};

// 任务列表
export const taskList = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_info/user/list",
    data: data,
    method: "POST"
  });
};

// 任务删除
export const taskDetele = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_info/user/detele",
    data: data,
    method: "POST"
  });
};

// 任务统计
export const uesrTaskCount = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_info/user/task_count",
    data: data,
    method: "POST"
  });
};

// 任务暂停
export const startSuspend = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_info/user/start_suspend",
    data: data,
    method: "POST"
  });
};
// 任务删除
export const userDetele = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_info/user/detele",
    data: data,
    method: "POST"
  });
};

// 任务停止
export const userStop = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_info/user/stop",
    params: data,
    method: "get"
  });
};

// 任务统计（子任务）
export const taskCount = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_details/user/count",
    data: data,
    method: "POST"
  });
};

// 任务列表（子任务）
export const defenderList = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_details/user/list",
    data: data,
    method: "POST"
  });
};

// 任务详情
export const taskDetailsInfo = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_details/info",
    params: data,
    method: "GET"
  });
};

// 删除任务（子任务）
export const taskDetailsDetele = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_details/detele",
    data: data,
    method: "POST"
  });
};